import React, { useState } from "react";
import { brand } from "../theme/brand.js";
import { btnPrimary, btnSecondary } from "../theme/button-styles.js";
import { cardStyle } from "../theme/card-styles.js";
import { inputStyle, labelStyle } from "../theme/input-styles.js";
import { useAuth } from "../hooks/useAuth.js";

export function Login({ onSuccess, onCancel }) {
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    if (submitting) return;
    if (!email.trim() || !password) {
      setErrorMessage("Enter both email and password.");
      return;
    }
    setSubmitting(true);
    const result = await signIn(email.trim(), password);
    setSubmitting(false);
    if (result?.ok) {
      setEmail("");
      setPassword("");
      setErrorMessage("");
      onSuccess();
    } else {
      setErrorMessage(result?.message || "Sign-in failed. Check your email and password.");
    }
  };

  const cancel = () => {
    setEmail("");
    setPassword("");
    setErrorMessage("");
    onCancel();
  };

  return (
    <div style={{ maxWidth: "380px", margin: "80px auto", padding: "0 24px" }}>
      <div style={cardStyle}>
        <h3 style={{ margin: "0 0 4px 0", fontSize: "16px", fontWeight: "600", color: brand.prussianBlue, fontFamily: brand.font }}>
          Admin Dashboard Login
        </h3>
        <p style={{ margin: "0 0 20px 0", fontSize: "13px", color: brand.textSecondary }}>
          Sign in with your Novo Legal admin or attorney account.
        </p>
        <label style={labelStyle}>Email</label>
        <input
          type="email"
          autoComplete="email"
          style={{ ...inputStyle, marginBottom: "10px" }}
          placeholder="you@example.com"
          value={email}
          onChange={(e) => { setEmail(e.target.value); setErrorMessage(""); }}
          autoFocus
        />
        <label style={labelStyle}>Password</label>
        <input
          type="password"
          autoComplete="current-password"
          style={{ ...inputStyle, marginBottom: "12px" }}
          placeholder="Password"
          value={password}
          onChange={(e) => { setPassword(e.target.value); setErrorMessage(""); }}
          onKeyDown={(e) => e.key === "Enter" && submit()}
        />
        {errorMessage && (
          <p style={{ margin: "0 0 12px 0", fontSize: "12px", color: brand.dangerRed }}>
            {errorMessage}
          </p>
        )}
        <div style={{ display: "flex", gap: "10px" }}>
          <button style={btnPrimary} onClick={submit} disabled={submitting}>
            {submitting ? "Signing in…" : "Log In"}
          </button>
          <button style={btnSecondary} onClick={cancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
